export const isEmpty = (value: string | number) => {
  if (typeof value === 'string') {
    return value.length === 0
  }
  if (typeof value === 'number') {
    return isNaN(value)
  }
  return false
}
